export default __webpack_public_path__ + "static/media/program-3.b6565175.jpg";